import { render, staticRenderFns } from "./NotiBar.vue?vue&type=template&id=30babfed&scoped=true&"
import script from "./NotiBar.vue?vue&type=script&lang=js&"
export * from "./NotiBar.vue?vue&type=script&lang=js&"
import style0 from "./NotiBar.vue?vue&type=style&index=0&id=30babfed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30babfed",
  null
  
)

export default component.exports